export default {
  calendar: null,
  calendarSelected: null,
  calendars: null,
};
